import { render } from "./EducationalTechnologyView.vue?vue&type=template&id=8f0d4590&scoped=true"
const script = {}

import "./EducationalTechnologyView.vue?vue&type=style&index=0&id=8f0d4590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0d4590"]])

export default __exports__